import React from 'react'
import { Col, Row } from '../../components/Component'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import { useGlobalStoreActions, useGlobalStoreData } from '../../store/globalStore'
import McPageHelpers from '../mc-components/McPageHelpers'

const AuthFooter = () => {
  const languageGSD = useGlobalStoreData.language()
  const versionGSD = useGlobalStoreData.version()
  const { setLanguage } = useGlobalStoreActions()
  const changeLanguage = (e, language) => {
    e.preventDefault()
    setLanguage(language)
  }

  const currentLanguage = McPageHelpers.languageOptions.find((lang) => lang.code === languageGSD)

  return (
    <div className="nk-footer nk-auth-footer-full">
      <div className="container-fluid">
        <Row className="g-3">
          <Col lg={6} className="order-lg-last">
            <ul className="nav nav-sm justify-content-center justify-content-lg-end">
              <li className="nav-item ">
                <UncontrolledDropdown direction="up">
                  <DropdownToggle
                    color="transparent"
                    className="dropdown-toggle dropdown-indicator has-indicator nav-link"
                  >
                    <span>{currentLanguage?.name || 'Language'}</span>
                  </DropdownToggle>
                  <DropdownMenu end className="dropdown-menu-sm">
                    <ul className="language-list">
                      {McPageHelpers.languageOptions.map(({ code, name, flag }) => (
                        <li key={code}>
                          <DropdownItem
                            tag="a"
                            href="#dropdownitem"
                            onClick={(e) => changeLanguage(e, code)}
                            className="language-item"
                          >
                            <img src={flag} alt="" className="language-flag"/>
                            <span className="language-name">{name}</span>
                          </DropdownItem>
                        </li>
                      ))}
                    </ul>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </li>
            </ul>
          </Col>
          <Col lg="6">
            <div className="nk-block-content text-center text-lg-start">
              <p className="text-soft dir-rtl">&copy; 2022 - {new Date().getFullYear()}
                <a href="https://marketcalculus.ai"
                   target="_blank" rel="noreferrer"> Market
                  Calculus</a> {versionGSD}</p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}
export default AuthFooter
